import { Tier } from '../../../../services/enums/Tier';

import loyaltyLogo from '../../../../assets/css/eva/resources/images/loyalty-iso-logo.svg';
import loyaltyLogoN from '../../../../assets/css/eva/resources/images/loyalty-iso-logo-negative.svg';

export const getLoyaltyLogoByTier = tierCode => ((tierCode === Tier.BASE) ? loyaltyLogoN : loyaltyLogo);
